/* eslint-disable no-loop-func */
import { IDs } from '../../helpers/IDs';
import * as Moment from 'moment';
import { DataService } from '../../services/data_service';
import { submitKennzahlen } from '../../bereiche/dateneingabe/functions/submitKennzahlen';
import { ApiService } from '../../services/api_service';

let triggerCheck = -1;

export function processKennzahlenImport(data: any, dataService: DataService, callback?: () => void, ignoreTrigger?: boolean) {
    // console.log('processKennzahlenImport ...');

    if (!ignoreTrigger) {
        ignoreTrigger = false;
    }

    const onProcessDone = () => {
        if (typeof callback === 'function') {
            callback();
        }
    };
    const konfiguration: any = (data[IDs.ENT_KONFIGURATION] || [])[0] || {};
    const unternehmen: any = (data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
    const registrierung: any = (data[IDs.ENT_REGISTRIERUNG] || [])[0] || {};
    if (
        (registrierung.test_registrierung === 1 || registrierung.schulung !== null || unternehmen.gewerk_tid === 'Kein Handwerk')
        && unternehmen.gewerk_tid_orig !== 148
    ) {
        // console.log('Keine Kennziffern-Übertragung');
        onProcessDone();
        return;
    }

    const triggerTime = new Date().getTime();
    triggerCheck = triggerTime;
    // console.log('Kennzahlen triggerCheck, triggerTime', triggerCheck, triggerTime);

    if (!ApiService.unternehmenInternal) {
        // console.log('submitKennzahlen', 'no unternehmenInternal');
        onProcessDone();
        return;
    }
    // console.log('KZ unt', unternehmen);
    if (!Object.keys(unternehmen).length) {
        // console.log('submitKennzahlen', 'no unternehmen');
        onProcessDone();
        return;
    }
    const gewerk = unternehmen.gewerk_tid_orig || unternehmen.gewerk_tid;
    const situation = unternehmen.betriebliche_situation_orig || unternehmen.betriebliche_situation;

    // HINWEIS: Kultur geht hier raus, da es keine betriebliche Situation gibt
    // ... wir könnten aber auch explizit prüfen ...


    if (!gewerk || (!situation && unternehmen.gewerk_tid_orig !== 148)) {
        // console.log('Kennzahlen Abbruch gewerk, situation, gewert_tid', gewerk, situation, unternehmen.gewerk_tid_orig);
        onProcessDone();
        return;
    }

    const tid = unternehmen.tid;
    const pseudo: string = `SUB_G${gewerk}_U${tid}`;

    // Wir laden hier in jedem Fall den aktuellen Stand
    dataService.loadData(IDs.ENT_KENNZAHLEN_IMPORT, {}, { resolve: true }, (res: any) => {
        if (!ignoreTrigger && triggerCheck !== triggerTime) {
            // console.log('Kennzahlen Abbruch trigger', triggerCheck, triggerTime);
            // Dann kam ein neuerer Trigger dazwischen
            onProcessDone();
            return;
        }
        dataService.loadData(IDs.ENT_KENNZAHLEN_WERTE, { betrieb: pseudo }, { resolve: true }, (res_roh: any) => {
            if (res && Array.isArray(res[IDs.ENT_KENNZAHLEN_IMPORT])) {
                console.log('Kennzahlen import Start...');
                const kz_import: any[] = res[IDs.ENT_KENNZAHLEN_IMPORT] || [];
                const jahrMax = Moment().year() - 1;
                let jahrMin = 2010;
                if (konfiguration.startjahr_datenerfassung > 1900) {
                    jahrMin = konfiguration.startjahr_datenerfassung;
                }
                let submitCount = jahrMax - jahrMin + 1;
                for (let i = jahrMin; i <= jahrMax; i++) {
                    const item_found = kz_import.find((item: any) => item.jahr === i);
                    submitKennzahlen(data, i, dataService, item_found, res_roh?.kennzahlen_werte || [], () => {
                        submitCount--;
                        if (submitCount === 0) {
                            // console.log('Kennzahlenspeicherung abgeschlossen');
                            onProcessDone();
                        }
                    });
                }
            } else {
                // console.log('Kennzahlen Abbruch', );
                onProcessDone();
            }
        }, IDs.MOD_ETOOL_ADMIN);
    }, IDs.MOD_ETOOL_ADMIN);
}
